import { apiClient } from "@/api/softphone_api";

export const getEnty = async ({ commit }, { enty, urlPath, mutation, config = {} }) => {
  const url = `/api/${urlPath}`;
  const res = await apiClient.get(url, config);
  console.log(`RESPONSE GET ENTY TO ${url}`, res);
  commit(mutation, { key: enty, value: res });
  return res;
};
export const saveEnty = async (
  { commit },
  { data, urlPath, mutation1, enty }
) => {
  console.log("DATA POST: ", data);
  const url = `/api/${urlPath}`;
  const res = await apiClient.post(url, data);
  console.log(`RESPONSE POST ENTY TO ${url}`, res);
  commit(mutation1, { key: enty, value: res.data });
  return res;
};
export const updateEnty = async (
  { commit },
  { key, keySearch, value, urlpath, mutation1, data }
) => {
  const url = `/api/${urlpath}${value}/`;
  const res = await apiClient.patch(url, data);
  console.log(`RESPONSE POST ENTY TO ${url}`, res);
  commit(mutation1, {
    key,
    keySearch,
    value,
    data: res.data,
  });
  return res;
};
export const deleteEnty = async (
  { commit },
  { key, keySearch, value, urlpath, mutation1 }
) => {
  const url = `/api/${urlpath}${value}/`;
  const res = await apiClient.delete(url);
  console.log(`RESPONSE POST ENTY TO ${url}`, res);
  commit(mutation1, {
    key,
    keySearch,
    value,
  });
  return res;
};

export const assignColorsToUsers = ({ state, commit }, datasetName) => {
  const data = state[datasetName]?.data;
  if (!Array.isArray(data)) return;

  const colorPalette = [
    "#f87979",
    "#f8b179",
    "#f8e879",
    "#b8f879",
    "#79f8c1",
    "#79d0f8",
    "#797ff8",
    "#c179f8",
    "#ff66cc",
    "#66ffcc",
    "#cc66ff",
    "#ffff66",
  ];

  const userColorMap = {};
  let index = 0;

  const newData = data.map((item) => {
    const usuario = item.Usuario;
    if (!userColorMap[usuario]) {
      userColorMap[usuario] = colorPalette[index % colorPalette.length];
      index++;
    }
    return {
      ...item,
      color: userColorMap[usuario], // 🎯 color agregado al objeto
    };
  });

  commit("setUserColors", userColorMap);
  commit("updateDataset", { datasetName, newData });
};
export const assignColorsToMetrics = ({ state, commit }, datasetName) => {
  const data = state[datasetName]?.data?.group_by_data;
  if (!Array.isArray(data)) return;

  const colorPalette = [
    "#f87979", "#f8b179", "#f8e879", "#b8f879",
    "#79f8c1", "#79d0f8", "#797ff8", "#c179f8",
    "#ff66cc", "#66ffcc", "#cc66ff", "#ffff66",
  ];

  const firstItem = data[0];
  if (!firstItem) return;

  const metricKeys = Object.keys(firstItem).filter(key => key !== "Label");

  const existing = state.metricColors || {};
  const newMap = { ...existing };
  let index = Object.keys(existing).length;

  metricKeys.forEach(metric => {
    if (!newMap[metric]) {
      newMap[metric] = colorPalette[index % colorPalette.length];
      index++;
    }
  });

  commit("setMetricColors", newMap);
};

